const {
  REACT_APP_PAPELZERO_ENDERECO,
  REACT_APP_URI_PROCESSO_PAPEL_ZERO,
  REACT_APP_HORUS_ENDERECO,
} = process.env

interface AmbienteConfig {
  papelZeroEndereco: string
  uriProcessoPapelZero: string
  horusEndereco: string
}

export const ambienteConfig: AmbienteConfig = {
  papelZeroEndereco: REACT_APP_PAPELZERO_ENDERECO || '',
  uriProcessoPapelZero: REACT_APP_URI_PROCESSO_PAPEL_ZERO || '',
  horusEndereco: REACT_APP_HORUS_ENDERECO || '',
}
